import axios from 'axios'
import { exportAxios } from '@/utils/axiosType'

export default {
  // 查询插件消费清单
  queryPluginConsumption(params) {
    return axios.post('/api/rendering/admin/task/export/queryPluginConsumption', params)
  },
  exportPluginConsumption(params) {
    return exportAxios('/api/rendering/admin/task/export/exportPluginConsumption', params)
  },
  /**
   * 查询导出列表
   * @param {number} [type] - 数据类型 1/消费清单 2/渲染列表 3/月初余额 4/计算量统计
   * @param {string} [startTime]
   * @param {string} [endTime]
   * @param {number} [pageNum]
   * @param {number} [pageSize]
   */
  queryExportList(params) {
    return axios.post('/api/rendering/admin/task/export/queryExportList', params)
  },
  /**
   * 下载数据
   * @param {number} [id]
   */
  getExcel(params) {
    return exportAxios('/api/rendering/admin/task/export/getExcel', params)
  },
  /**
   * 删除数据
   * @param {number} [id]
   */
  delExportList(params) {
    return axios.post('/api/rendering/admin/task/export/delExportList', params)
  },
}
